















































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import BannerService from '@/services/banner.service';
import { BannerDto } from '@/dto';
import { CONST_YN, Pagination, YN } from '@/common';
import toast from '../../../../resources/assets/js/services/toast.js';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import {
  BANNER_TYPE,
  CONST_BANNER_TYPE,
  CONST_LINK_TYPE,
  LINK_TYPE,
} from '../../../services/shared';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import { CodeManagementDto } from '@/services/init/dto/index.js';
import CodeManagementService from '../../../services/code-management.service';

@Component
export default class BannerList extends BaseComponent {
  private bannerList: BannerDto[] = [];
  private bannerSearchDto = new BannerDto();
  private bannerCreateDto = new BannerDto();
  private pagination = new Pagination();
  private dataLoading = false;
  private bannerTotalCount = null;
  private ynSelect: YN[] = [...CONST_YN];
  private bannerTypeSelect: CodeManagementDto[] = [];
  private linkTypeSelect: CodeManagementDto[] = [];
  private bannerImage: FileAttachmentDto[] = [];
  private bannerMobileImage: FileAttachmentDto[] = [];
  private startedDate: Date = null;
  private endedDate: Date = null;

  getTypeCodes() {
    CodeManagementService.findAnyCode('BANNER_TYPE').subscribe(res => {
      this.bannerTypeSelect = res.data;
    });
    CodeManagementService.findAnyCode('LINK_TYPE').subscribe(res => {
      this.linkTypeSelect = res.data;
    });
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.bannerSearchDto, this.pagination);
    }
    BannerService.findAll(this.bannerSearchDto, this.pagination).subscribe(
      res => {
        if (res) {
          this.dataLoading = false;
          this.bannerList = res.data.items;
          this.bannerTotalCount = res.data.totalCount;
        }
      },
    );
  }

  search() {
    this.findAll(true, true);
  }
  paginateSearch() {
    this.findAll(true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.bannerSearchDto = new BannerDto();
      this.findAll();
    }
  }

  // create banner
  createBanner() {
    if (this.bannerImage.length > 0) {
      this.bannerCreateDto.image = this.bannerImage;
    } else {
      delete this.bannerCreateDto.image;
    }

    if (this.bannerMobileImage.length > 0) {
      this.bannerCreateDto.mobileImage = this.bannerMobileImage;
    } else {
      delete this.bannerCreateDto.mobileImage;
    }

    this.bannerCreateDto.started = new Date(`${this.startedDate} 00:00:00`);
    this.bannerCreateDto.ended = new Date(`${this.endedDate} 23:59:59`);

    BannerService.create(this.bannerCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.clearOut();
        this.$bvModal.hide('add_banner');
      }
    });
  }

  // upload banner image
  async upload(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.BANNER, [
        file,
      ]);
      this.bannerImage = [];
      this.bannerImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
    }
  }

  // upload banner image
  async uploadMobile(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.BANNER, [
        file,
      ]);
      this.bannerMobileImage = [];
      this.bannerMobileImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
    }
  }

  clearOutBannerCreateDto() {
    this.bannerImage = [];
    this.bannerMobileImage = [];
    this.bannerCreateDto = new BannerDto();
    this.$bvModal.hide('add_banner');
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.bannerSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getTypeCodes();
  }
}
